import React, { Component } from 'react';
import * as GlobalActions from '../../../reducers/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import LandingStyles from '../LandingStyles';
import LandingImages from '../LandingImages';
import { S3HOST } from '../../../ApiConstants';
import view from '../../../Enums';
import Fade from 'react-reveal/Fade';
import { NavLink } from 'react-router-dom';
import { Event } from '../Tracking/Track';
import { hmsSelfOnboardingEnabled } from '../../../config/countryConfig';

class PeopleCheckIntoOyo2 extends Component {


  render() {
    let gc = this.props.gc;
    let guc = this.props.guc;
    let gs = this.props.gs;
    let gi = this.props.gi;

    let style = {
      width: '100%',
      position: 'relative',
      overflow: 'hidden'
    };

    let imgStyle = {
      objectFit: 'contain',
      width: '100%'
    };

    if (this.props.viewMode == view.MOBILE) style['height'] = 296;
    if (this.props.mobileVsmall) {
      imgStyle = {
        overflow: 'hidden',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      };
    }

    return (
      <React.Fragment>
        {this.props.globalData.landing_translations && this.props.viewMode && (
          <div style={style} ref={this.props.setPeopleCheckInRef}>
            <img style={imgStyle} src={gi('people_check_in')} />

            <div style={gs('no_of_people_parent')}>
              <Fade>
                <div style={gs('no_of_people_text_container')}>
                  <div style={gs('no_of_people')}>
                    {gc('no_of_people_checking_in')}
                  </div>
                  <div style={gs('no_of_people_content')}>
                    {gc('people_check_into')}
                  </div>
                </div>

                <div style={gs('no_of_people_lower')}>
                  <div style={gs('no_of_people_lower_text')}>
                    {gc('with_each_booking')}
                  </div>
                  {hmsSelfOnboardingEnabled() ? <button
                      className="hoverColor"
                      style={gs('no_of_people_lower_btn')}
                      onClick={() => {
                        Event(
                            'Partner Page',
                            'Request a call clicked after 5 people check into OYO',
                            '',
                            ''
                        );
                        this.props.redirectToHms();
                      }
                      }
                  >
                    {hmsSelfOnboardingEnabled() ? guc('get_started') : guc('get_associated')}
                  </button>: <NavLink
                    exact
                    to="/form"
                    style={{ textDecoration: 'none', color: '#ffffff' }}
                    onClick={e => {
                      e.preventDefault();
                      this.props.handleScrollToForm();
                    }}
                  >
                    <button
                      className="hoverColor"
                      style={gs('no_of_people_lower_btn')}
                      onClick={() =>
                        Event(
                          'Partner Page',
                          'Request a call clicked after 5 people check into OYO',
                          '',
                          ''
                        )
                      }
                    >
                      {guc('join_us')}
                    </button>
                  </NavLink>}
                </div>
              </Fade>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    globalActions: bindActionCreators(GlobalActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    globalData: state.globalReducer
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PeopleCheckIntoOyo2);
